import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mbs_auth_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API, timeout: 60000 });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/login") && !url.includes("/auth/forgot") && !url.includes("/auth/reset")) {
      setToken(null);
      if (window.location.pathname !== "/login") {
        window.location.replace("/login?next=" + encodeURIComponent(window.location.pathname + window.location.search));
      }
    }
    return Promise.reject(err);
  }
);

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_wooden-quoter/artifacts/8rw34cuy_encabezado%20logo%20carta.png";

export const formatMXN = (n) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("es-MX", { day: "2-digit", month: "short", year: "numeric" }).format(new Date(iso));
  } catch {
    return iso;
  }
};

export const formatBirthday = (raw) => {
  if (!raw) return "";
  const parts = raw.split("-");
  const monthNames = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
  try {
    if (parts.length === 3) {
      const [, mm, dd] = parts;
      return `${parseInt(dd, 10)} ${monthNames[parseInt(mm,10)-1]}`;
    }
    if (parts.length === 2) {
      const [mm, dd] = parts;
      return `${parseInt(dd, 10)} ${monthNames[parseInt(mm,10)-1]}`;
    }
  } catch (e) {
    console.warn("formatBirthday failed for", raw, e);
  }
  return raw;
};

export const CATEGORIAS = ["Residencial", "Comercial", "Hoteleria"];
export const STATUSES = ["Borrador", "Enviada", "En proceso", "Aprobada", "Rechazada"];

// CRM pipeline columns (mapped to status field)
export const CRM_COLUMNS = [
  { id: "Borrador", title: "Borrador", color: "#7A756D" },
  { id: "Enviada", title: "Enviada", color: "#8B5A33" },
  { id: "En proceso", title: "En seguimiento", color: "#D4A373" },
  { id: "Aprobada", title: "Ganada", color: "#4A7C59" },
  { id: "Rechazada", title: "Perdida", color: "#BC4749" },
];

export const statusColor = (s) => {
  switch (s) {
    case "Aprobada": return "bg-[#4A7C59]/15 text-[#3a6347] border-[#4A7C59]/30";
    case "Enviada": return "bg-[#8B5A33]/12 text-[#6D4525] border-[#8B5A33]/30";
    case "En proceso": return "bg-[#D4A373]/20 text-[#7d5a2a] border-[#D4A373]/40";
    case "Rechazada": return "bg-[#BC4749]/12 text-[#8a3537] border-[#BC4749]/30";
    default: return "bg-muted text-muted-foreground border-border";
  }
};

// Resize an image File to max width, return JPEG base64 (data: URL)
export const fileToCompressedDataUrl = (file, maxW = 1280, quality = 0.8) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxW / img.width);
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
